import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";

import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../../pages/popup/PopupProfileEdit"
import PopupRegisterCoupon from "../../pages/popup/PopupRegisterCoupon"

import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import PaginationInquiryList from '../../components/PaginationInquiryList';
import { Rotate } from 'react-reveal';

export default function InquiryList() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const fileRef = useRef();

    const [coupon, setCoupon] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if(!mbData?.idx) {
            navigate(routes.main);
        } 
    }, []);

    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div 
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default}/>
                            <p>{lang === 0 ? '문의 내역' : 'Inquiry History'}</p>
                        </div>

                        <div className="profile_edit coupon inquiry">
                            <div className="coupon_title_box">
                                <p>{lang === 0 ? '문의 내역' : 'Inquiry History'}</p>

                                <button
                                    type="button"
                                    onClick={() => {
                                        navigate(routes.Inquiry)
                                    }}
                                >
                                    <img src={require("../../assets/icon/Comment.svg").default}/>
                                    {lang === 0 ? '1:1 문의하기' : '1:1 Inquiry'}
                                </button>
                            </div>

                            <PaginationInquiryList />
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}